import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { SearchCustomerComponent } from '../search-customer/search-customer.component';
import { KeyboardComponent } from '../keyboard/keyboard.component';
import { InvoiceItemComponent } from '../invoice-item/invoice-item.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {

  public menu_item_id = '100';
  public add_auth;

  search_obj = {
    'placeholder': 'اسم المورد/ رقم المورد/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`supplier`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'supplier_name', 'supplier_name_en', 'mobile']
    }]
  };

  model = {
    'table_name': 'purchase_order', 'purchase_order_id': '0', 'purchase_order_no': '',
    'purchase_order_date': '', 'expiry_date': '', 'supplier_no': '', 'supplier_name': '',
    'calc_tax': '1', 'print_tax': '1', 'total': '', 'tax': '', 'discount': '', 'comment': '',
    'invoice_type': 'purchase_order', 'payment_voucher_no': '', 
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  data_model = { 'orderDate': new Date(), 'expiryDate': new Date(), 'final_total': '' };

  print_type;

  supplierList = [];
  supplierDetail = '';

  // invCondList = [];
  dp = [];
  saveClicked = false;

  Supplier_Placeholder; Success_Msg; Error_Msg; One_Item_Msg;
  Pur_Order_No; Supplier_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Supplier_Placeholder').subscribe((res: string) => {
      this.Supplier_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Supplier_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Pur_Order_No').subscribe((res: string) => {
      this.Pur_Order_No = res;
    });

    translate.get('Supplier_Msg').subscribe((res: string) => {
      this.Supplier_Msg = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.model['calc_tax'] = this.utils.getParamValue('cal_tax');
    this.print_type = this.utils.getParamValue('print_type');

    // get leaf supplier accts
    let branch_list = [{ 'branch_id': this.model['branch_id'] }, { 'branch_id': '0' }];
    let parent_acct = this.applicationConstants.main_acct_config['supplier'];
    let obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true, 
      check_cc: false, type: 'supplier', branch_list: branch_list };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.supplierList = data.data['list'];
      });
  }

  // onChangeSearch = function (search_result: object) {
  //   // console.log(search_result);
  //   this.model['supplier_name'] = search_result['value'];
  //   this.model['supplier_no'] = search_result['no'];
  // }

  onChangeSupplier = function (acct_number: string) {
    this.model['supplier_no'] = acct_number;
    this.model['supplier_name'] = (document.getElementById('search_value_0') as HTMLInputElement).value;
  }

  onChange = function (dpList: any) {
    // this.dp = dpList;
    this.dp = dpList['dp'];
  }

  saveOrder(save_type) {
    this.saveClicked = true;

    if (this.model['total'] == '' || Number(this.model['total']) == 0) {
      alert(this.One_Item_Msg);
      this.saveClicked = false;
      return;
    }
    
    if (this.model['supplier_no'] == '') {
      alert(this.Supplier_Msg);
      this.saveClicked = false;
      return;
    }

    this.model['purchase_order_date'] = this.data_model['orderDate'].getFullYear() + "-" +
      (this.data_model['orderDate'].getMonth() + 1) + "-" + this.data_model['orderDate'].getDate() + " " +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();

    this.model['expiry_date'] = this.data_model['expiryDate'].getFullYear() + "-" +
      (this.data_model['expiryDate'].getMonth() + 1) + "-" + this.data_model['expiryDate'].getDate() + " " +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();


    let values = [];
    values.push(this.model);

    this.dp.forEach(element => {

      if (element.sub_item_number != '' || (element.sub_item_name != '' && element.total_price != '')) {

        values.push({
          'table_name': 'purchase_order_item', 'purchase_order_no': this.model['purchase_order_no'],
          'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name,
          'count': element.count, 'price': element.price, 'unit_id': element.unit_id,
          'total_price': element.total_price, 'tax_no': element.tax_no, 'tax_amount': element.tax_amount,
          'discount': element.discount, 'comment': element.comment
        });
      }
    });

    let current_year = new Date().getFullYear();
    let prefix = this.applicationConstants.branch_id + "-" + current_year;
    let obj = { cmd: 'add', values: values, pk: 'purchase_order_no', id: 'purchase_order_id', main_table: 'purchase_order', prefix: prefix };
    //console.log(values);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          this.model['purchase_order_no'] = data.status['msg'][0]['number'];
          alert(this.Success_Msg + ", " + this.Pur_Order_No + ": " + this.model['purchase_order_no']);

          if (save_type == 'print')
            window.open(this.applicationConstants.generatePDF + "?type=purchase_order&no=" + this.model['purchase_order_no'], "_blank");

          this.router.navigate(['sub_menu/7/purchase_order_list']);
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });

  }

}
